import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";

interface SendRejectedTaxSubmissionRequest {
    taxSubmissionId: string;
}

export const useSendRejectedTaxSubmission = () => {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders({ method: "PATCH" });
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (request: SendRejectedTaxSubmissionRequest) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/send-rejected-tax-submission/${request.taxSubmissionId}`,
                {
                    headers,
                    method: "PATCH",
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissions"],
            });
            queryClient.invalidateQueries({ queryKey: ["useGetKPIs"] });
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissionDetail"],
            });
        },
        meta: {
            errorMessage: t("errors.messages.sendRejectedTaxSubmission"),
        },
    });

    return mutation;
};
